import { render } from "./BaseLoadingScreen.vue?vue&type=template&id=1496148d&scoped=true"
import script from "./BaseLoadingScreen.vue?vue&type=script&lang=js"
export * from "./BaseLoadingScreen.vue?vue&type=script&lang=js"

import "./BaseLoadingScreen.vue?vue&type=style&index=0&id=1496148d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1496148d"]])

export default __exports__